import { employeeRoles } from './type';

export const getFullName = (
  firstName: string | null,
  lastName: string | null,
): string => {
  const nameArray: string[] = [];
  if (firstName !== null && firstName.length > 0) {
    nameArray.push(firstName);
  }
  if (lastName !== null && lastName.length > 0) {
    nameArray.push(lastName);
  }
  return nameArray.length == 0 ? '-' : nameArray.join(' ');
};

export const getFullNameWithMiddleName = (
  firstName: string | null,
  middleName: string | null,
  lastName: string | null,
): string => {
  const nameArray: string[] = [];
  if (firstName !== null && firstName.length > 0) {
    nameArray.push(firstName);
  }
  if (middleName !== null && middleName.length > 0) {
    nameArray.push(middleName);
  }
  if (lastName !== null && lastName.length > 0) {
    nameArray.push(lastName);
  }
  return nameArray.length == 0 ? '-' : nameArray.join(' ');
};

export function formatName(
  firstName: string | null,
  middleName: string | null,
  lastName: string | null,
  suffix: string | null,
): string {
  const nameParts: string[] = [];

  if (lastName) {
    nameParts.push(lastName + ',');
  }

  if (firstName) {
    nameParts.push(firstName);
  }

  if (middleName) {
    nameParts.push(middleName);
  }

  let fullName = nameParts.join(' '); // Join all parts with a space

  if (suffix) {
    fullName += `, ${suffix}`; // Append suffix with a comma
  }

  return fullName.trim(); // Return the formatted name'; // Trim any extra spaces
}

export const getRoleName = (employee: string): string => {
  if (!employee) {
    return '';
  }

  const roleLabels = employee.split(',').map((emp: string) => {
    const empRoles = employeeRoles.find((empRole) => empRole.id === emp);
    return empRoles ? empRoles.label : '';
  });

  return roleLabels.join(', ');
};

export const removeDoubleCommas = (input: string): string => {
  return input.replace(/, ,/g, ',').replace(/,,/g, ',');
};
